import * as apiUtils from "./apiUtils";

const baseUrl = getIdentityBaseUrl();

function getIdentityBaseUrl() {
  try {
    return process.env.IDEN_URL || "";
  } catch {
    return "";
  }
}

function requireBaseUrl() {
  if (!baseUrl) {
    throw new Error("Identity service URL is not configured.");
  }

  return baseUrl;
}

export function authenticate(
  username,
  password,
  portalId,
  brandId,
  isPhone,
  options,
) {
  return apiUtils
    .post(
      `${requireBaseUrl()}/token/authenticate`,
      {
        username,
        password,
        portalId,
        brandId,
        isPhone,
      },
      options,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function authenticatePlus(userId, resetCode, portalId, brandId) {
  return apiUtils
    .post(`${requireBaseUrl()}/token/authenticate-pluswebuser`, {
      userId,
      resetCode,
      portalId,
      brandId,
    })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function refreshToken(accessToken, refreshToken, userId) {
  return apiUtils
    .post(`${requireBaseUrl()}/token/refresh`, {
      accessToken,
      refreshToken,
      userId,
    })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function revokeToken(userId) {
  return apiUtils
    ._delete(`${requireBaseUrl()}/token/revoke/${userId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function resetOptions(email, portalId, isPhone, phoneNumber) {
  return apiUtils
    .post(`${requireBaseUrl()}/auth/password/reset-code-options`, {
      email,
      portalId,
      isPhone,
      phoneNumber,
    })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function generateResetCode(
  email,
  portalId,
  brand,
  mechanism,
  options = {},
) {
  const body = {
    email,
    portalId,
    brand,
    mechanism,
  };

  if (options?.isPhone) {
    body.isPhone = options?.isPhone;
  }

  if (options?.phoneNumber) {
    body.phoneNumber = options?.phoneNumber;
  }

  return apiUtils
    .post(`${requireBaseUrl()}/auth/password/generate-reset-code`, body)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function verifyResetCode(userId, resetCode) {
  return apiUtils
    .post(`${requireBaseUrl()}/auth/password/verify-reset-code`, {
      userId,
      resetCode,
    })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function resetNow(userId, newPassword, resetCode) {
  return apiUtils
    .patch(`${requireBaseUrl()}/auth/password/reset`, {
      userId,
      newPassword,
      resetCode,
    })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function validatePassword(password) {
  return apiUtils
    .post(`${requireBaseUrl()}/user/validatepassword`, { password })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updateUser(user) {
  return apiUtils
    .patch(`${requireBaseUrl()}/user`, user)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
